import React from "react";
import { useContent } from "../context/ContentContext";
import { PageHero } from "../components/PageHero";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const { content } = useContent();
  const faq = content?.faq || [];

  return (
    <div data-testid="faq-page">
      <PageHero overline="Good To Know" title="Questions" subtitle="Everything you might be wondering, answered." />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20">
        <div className="mb-10 bg-olive text-soft-white rounded-lg py-5 px-6 text-center" data-testid="faq-limited-guest-note">
          We have a very limited guest list and can only accommodate the people listed on the invite.
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faq.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-taupe/40" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-serif text-xl sm:text-2xl text-matte text-left hover:text-olive hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-taupe text-base leading-relaxed pb-6">
                {f.a}
                {/registered|registry/i.test(f.q) && (
                  <div className="mt-3"><Link to="/registry" className="text-olive underline underline-offset-4" data-testid="faq-registry-link">Visit our Registry →</Link></div>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
